import ChartPie from './chartPie'
export default ChartPie
